export const miscTailHc = {
  maquetaCreateNav: {
    guidesAria: "Guias em vídeo e ajuda",
    guidesTip: "Guias e ajuda",
    availabilityPricesTitle: "Disponibilidade e Tarifas",
    hotelCalendarSubtitle: "Disponibilidade e reservas por quarto",
    availabilityPricesSubtitle: "Preços, disponibilidade e estadia mínima",
  },
  maquetaNav: {
    guidesAria: "Guias em vídeo e ajuda",
    guidesTip: "Guias e ajuda",
    novedadesAria: "Novidades do sistema",
    novedadesTip: "Novidades",
    tourTip: "Novidades: visita guiada",
    tourAria: "Abrir a visita às novidades",
    backToPanel: "Voltar ao painel",
    accountTitle: "Configurações da conta",
    agentIaTitle: "Agente de IA",
    directBookingsTitle: "Reservas diretas",
    listingsTitle: "Configurações de anúncios",
  },
  navMovil: {
    menuTitle: "Menu",
    home: "Início",
    calendar: "Calendário",
    reservations: "Reservas",
    checkins: "Check-ins",
    housekeeping: "Limpeza",
    channels: "Canais de reservas",
    settings: "Configurações",
    settingsDesktopOnly: "Disponível apenas na versão desktop",
    experiences: "Experiências",
  },
  register: {
    terms: "Regulamento",
    privacy: "Política de privacidade",
    loginError: "Erro ao iniciar sessão.",
  },
  buttonSave: {
    savingRoom: "Salvando quarto...",
  },
  firstForm: {
    name: "Nome",
    phone: "Telefone",
  },
  final: {
    guestsRegistered: "Hóspedes registrados",
    registrationsCompleted: "Registros concluídos",
    registrationTime: "Horário do registro: ",
    shareRegistrationLink: "Compartilhar link de registro",
  },
  scannerPdf417: {
    captureCode: "Capturar código",
    focusInstruction: "Focalize e capture o código de barras do seu documento",
  },
  configNotifications: {
    title: "Notificações",
    propertyLabel: "Propriedade",
    phoneInstruction: "Insira o número de telefone que deseja utilizar para receber as notificações de solicitações de serviço ou check-ins feitos pelos hóspedes através do WhatsApp",
    saveWhatsapp: "Salvar WhatsApp",
    editWhatsapp: "Editar WhatsApp",
    configTitle: "Configurações",
    serviceNotifications: "Notificações de serviços",
    checkinNotifications: "Notificações de check-in",
    active: "Ativadas",
    inactive: "Desativadas",
    whatsappRequired: "Você deve inserir o WhatsApp",
    swalTitle: "WhatsApp para as notificações da sua propriedade",
    swalText: "Você receberá todas as notificações dos serviços solicitados e dos check-ins dos hóspedes ",
    cancel: "Cancelar",
    whatsappAdded: "WhatsApp adicionado com sucesso",
  },
  modalPoliceData: {
    headerSub: "Insira suas credenciais de acesso ao sistema",
    closeAria: "Fechar",
    entityName: "Nome da entidade",
    usernamePlaceholder: "Insira seu usuário",
    passwordPlaceholder: "Insira sua senha",
    hide: "Ocultar",
    show: "Mostrar",
    lessorExample: "Ex.: 12345",
    establishmentExample: "Ex.: 67890",
    saving: "Salvando…",
    listingNotFound: "O anúncio associado não foi encontrado.",
    saveFailed: "Não foi possível salvar o SES Hospedajes.",
  },
  notificaciones: {
    title: "Notificações",
    propertyLabel: "Propriedade",
    phoneInstruction: "Insira o número de telefone que deseja utilizar para receber as notificações de solicitações de serviço ou check-ins feitos pelos hóspedes através do WhatsApp",
    saveWhatsapp: "Salvar WhatsApp",
    editWhatsapp: "Editar WhatsApp",
    configTitle: "Configurações",
    serviceNotifications: "Notificações de serviços",
    checkinNotifications: "Notificações de check-in",
    active: "Ativadas",
    inactive: "Desativadas",
    whatsappRequired: "Você deve inserir o WhatsApp",
    swalTitle: "WhatsApp para as notificações da sua propriedade",
    swalText: "Você receberá todas as notificações dos serviços solicitados e dos check-ins dos hóspedes ",
    cancel: "Cancelar",
    whatsappAdded: "WhatsApp adicionado com sucesso",
  },
  admins: {
    listTitle: "Lista de managers",
    newManager: "Novo manager",
    today: "Hoje",
    thName: "Nome",
    thEmail: "E-mail",
    thRegistered: "Registrado",
    edit: "Editar",
    delete: "Excluir",
    userLabel: "Usuário",
    emailLabel: "E-mail",
    passwordLabel: "Senha",
    cancel: "Cancelar",
    save: "Salvar",
    createdOk: "Criado com sucesso",
    requestError: "Erro na solicitação",
    updatedOk: "Atualizado com sucesso",
    deletedOk: "Excluído com sucesso",
  },
};
